module.exports = __webpack_public_path__ + "static/img/67040F_1_2_R_20190723_LC.a493abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67040F_1_2_R_20190723_LC.png
// module id = wq6x
// module chunks = 0